import React, { useEffect, useState } from "react";

import OnrcAllotedDistAfso from "./OnrcAllotedDistAfso";
import OnrcAllotedSubDistAfso from "./OnrcAllotedSubDistAfso";
import OnrcAllotedSubDistDepot from "./OnrcAllotedSubDistDepot";

const OnrcAllotedIntAfso = ({ heading, sub = "" }) => {

    const [districtView, setDistrictView] = useState(null);
    const [depotView, setDepotView] = useState(null);
    const [fpsView, setFpsView] = useState(null);

    const [cmonth, setMonth] = useState(new Date().getMonth() + 1);
    const [cyear, setYear] = useState(new Date().getFullYear());

    const [comm, setComm] = useState({ id: "", name: "" });
    const [scheme, setScheme] = useState({ id: "0", name: "ALL" });

    const [dist, setDist] = useState({ id: "all", name: "ALL" });
    const [mandal, setMandal] = useState({ id: "all", name: "ALL" });

    const [districtDrop, setDistrictDrop] = useState([]);
    const [mandalDrop, setMandalDrop] = useState([]);

    const [optionsSet, setOptionsSet] = useState({});
    const [schemeList, setSchemeList] = useState({});

    const [reportType, setReportType] = useState("IMPDS");

    const Months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    const Years = [
        new Date().getFullYear() - 1,
        new Date().getFullYear(),
        new Date().getFullYear() + 1
    ];
    const getMonthName = (m) => Months[m - 1];


    /* ---------- District List ---------- */
    useEffect(() => {
        setDist({ id: "all", name: "ALL" });
        setMandal({ id: "all", name: "ALL" });
        setMandalDrop([]);
        setDistrictDrop([]);
        setComm({ id: "", name: "" });
        setScheme({ id: "0", name: "ALL Scheme" });

        setDistrictView(null);
        setDepotView(null);
        setFpsView(null);

        fetch(`${process.env.REACT_APP_URL_SALE}/reports/get-all-district${sub}`)
            .then(res => res.json())
            .then(setDistrictDrop)
            .catch(console.error);

    }, [heading, sub]);

    /* ---------- Depot Dropdown ---------- */
    useEffect(() => {
        setMandal({ id: "all", name: "ALL" });
        setMandalDrop([]);

        if (dist.id !== "all" && dist.id) {
            fetch(`${process.env.REACT_APP_URL_SALE}/reports/get-dist-mandal/${dist.id}`)
                .then(res => res.json())
                .then(setMandalDrop)
                .catch(console.error);
        }
    }, [dist.id, sub]);

    /* ---------- Commodity / Scheme ---------- */
    useEffect(() => {
        setOptionsSet({});
        setSchemeList({});
        setComm({ id: "", name: "" });
        setScheme({ id: "0", name: "ALL Scheme" });

        fetch(`${process.env.REACT_APP_URL_SALE}/reports/get-onrc-commodity/${cmonth}/${cyear}`)
            .then(res => res.json())
            .then(data => {
                const commMap = {};
                const schMap = {};

                data.forEach(item => {
                    commMap[item.id] = item.name;

                    if (item.scheme_id && item.scheme_name_en) {
                        schMap[item.scheme_id] = item.scheme_name_en;
                    }
                });

                setOptionsSet(commMap);
                setSchemeList(schMap);
            })
            .catch(console.error);
    }, [cmonth, cyear]);


    /* ---------- Submit ---------- */
    const handleSubmit = () => {
        if (!comm.id) {
            alert("Please select Commodity");
            return;
        }

        setDepotView(null);
        setFpsView(null);

        setDistrictView(
            <OnrcAllotedDistAfso
                month={cmonth}
                year={cyear}
                comm_id={comm.id}
                commname={comm.name}
                scheme={scheme.id}
                 reportType={reportType}
                // heading={`${heading} - ${cmonth}/${cyear}`}
                heading={`${heading}-${cyear}-${comm.name}-${getMonthName(cmonth)}-${reportType}`}

                setDepotView={setDepotView}
                setFpsView={setFpsView}
            />
        );
    };

    return (
        <div className="wrapper row3">
            <div id="container">

                <table width="100%">
                    <thead>
                        <tr className="tableheader">
                            <th colSpan={14}>{heading}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td align="center">
                                <b>Month:</b></td>
                                <td><select value={cmonth} onChange={e => setMonth(+e.target.value)}>
                                    {Months.map((m, i) => (
                                        <option key={i} value={i + 1}>{m}</option>
                                    ))}
                                </select>
                            </td>

                            <td align="center">
                                <b>Year:</b></td>
                               <td> <select value={cyear} onChange={e => setYear(+e.target.value)}>
                                    {Years.map(y => (
                                        <option key={y} value={y}>{y}</option>
                                    ))}
                                </select>
                            </td>

                            <td><b>Commodity:</b></td>
                            <td>
                                <select
                                    value={comm.id}
                                    onChange={e =>
                                        setComm({
                                            id: e.target.value,
                                            name: e.target.options[e.target.selectedIndex].text
                                        })
                                    }
                                >
                                    <option value="">--Select--</option>
                                    {Object.entries(optionsSet).map(([id, name]) => (
                                        <option key={id} value={id}>{name}</option>
                                    ))}
                                </select>
                            </td>

                            <td><b>Scheme:</b></td>
                            <td>
                                <select
                                    value={scheme.id}
                                    onChange={e =>
                                        setScheme({
                                            id: e.target.value,
                                            name: e.target.options[e.target.selectedIndex].text
                                        })
                                    }
                                >
                                    <option value="0">ALL Scheme</option>

                                    {Object.entries(schemeList).map(([id, name]) => (
                                        <option key={id} value={id}>
                                            {name}
                                        </option>
                                    ))}
                                </select>

                            </td>

                            <td>
                                <b>District:</b></td>
                                <td><select
                                    value={dist.id}
                                    onChange={e =>
                                        setDist({
                                            id: e.target.value,
                                            name: e.target.options[e.target.selectedIndex].text
                                        })
                                    }
                                >
                                    <option value="all">ALL District</option>
                                    {districtDrop.map(d => (
                                        <option key={d.id} value={d.id}>{d.name}</option>
                                    ))}
                                </select>
                            </td>

                            <td>
                                <b>Mandal :  </b> </td>
                                <td><select
                                    value={mandal.id}
                                    onChange={(e) => setMandal({ id: e.target.value, name: e.target.options[e.target.selectedIndex].text })}

                                >
                                    <option value='all'>All Mandal</option>
                                    {
                                        mandalDrop.map((item, index) => (
                                            <option value={item.id}>{item.name}</option>
                                        ))
                                    }
                                </select>
                            </td>
                            <td><b>Type:</b></td>
                            <td>
                                <select
                                    value={reportType}
                                    onChange={e => setReportType(e.target.value)}
                                >
                                    <option value="IMPDS">IMPDS</option>
                                    <option value="REG">REG</option>
                                </select>
                            </td>
                        </tr>

                        <tr>
                            <td colSpan={14} align="center">
                                <button onClick={handleSubmit} className="button button2">
                                    Submit
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <br />

                <div id="detailsER">
                    {districtView}
                    {depotView}
                    {fpsView}
                </div>

            </div>
            <br /><br /><br />
        </div>
    );
};

export default OnrcAllotedIntAfso;
